import { BaseError } from "./base-error.js";
export class ForbiddenError extends BaseError {
    static code = 'ForbiddenError';
    static statusCode = 403;
    data;
    constructor(message = 'Forbidden Error', data, options = {}) {
        super(message, options);
        this.data = data;
    }
}
